/**
 * `<SignUpPage>` — the in-app sign-up surface, rendered at `/sign-up/*`.
 *
 * Mirror of `<SignInPage>` but renders Clerk's `<SignUp />` component for the
 * account-creation flow (email + password + verification code + optional
 * social provider). Same slate appearance — uses the shared CLERK_APPEARANCE
 * config so the two pages look identical and consistent.
 *
 * Marketing-site CTAs link here via /sign-in by default; users get to /sign-up
 * by clicking Clerk's "Don't have an account? Sign up" link inside the SignIn
 * component (Clerk handles the route swap).
 */

import { SignUp } from '@clerk/clerk-react';
import { CLERK_APPEARANCE } from './SignInPage';

export function SignUpPage(): JSX.Element {
  return (
    <div className="auth-surface">
      <a href="https://aletheiapkm.com" className="auth-surface__brand" aria-label="Aletheia home">
        <span className="auth-surface__name">aletheia</span>
      </a>

      <div className="auth-surface__hero">
        <div className="auth-surface__eyebrow">
          your knowledge <span className="tick">·</span> revealed
        </div>
        <h1 className="auth-surface__title">
          Everything you capture, ready to <em>just ask.</em>
        </h1>
        <p className="auth-surface__sub">
          Create your private workspace and drop in your vault. Everything you’ve
          captured lands in <strong>one place, organized for you</strong> — then ask
          it anything and get a real answer, with the sources to back it up.
        </p>
      </div>

      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl="/sign-in"
        appearance={CLERK_APPEARANCE}
      />
    </div>
  );
}
